export enum PeriodType {
  Years = 'years',
  Months = 'months'
}
